import Image from "next/image";

export const VekaColors = () => {
  const n = 21;
  return (
    <div className="relative px-1 py-8 sm:px-2">
      Kolory:
      <div className="mx-auto flex max-w-screen-xl flex-col py-4 lg:flex-row">
        <div className="grid grid-cols-6 sm:grid-cols-10 md:grid-cols-12 lg:grid-cols-16">
          {Array.from({ length: n - 1 }, (_, i) => i + 1).map((colorIndex) => (
            <div className="p-1" key={`veka-color-${colorIndex}`}>
              <Image
                alt={`veka-color-${colorIndex}`}
                height={100}
                src={`/img/pvc/vekaColors/VEKA_${colorIndex}.png`}
                width={100}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
